import { getSupportedFormatsString } from './FileUpload.helpers';

export const MAX_MEGABYTE = 6;
export const DOCUMENT_MAX_FILE_SIZE = MAX_MEGABYTE * 1024 * 1024;
export const IMG_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const DOC_FORMATS = ['application/pdf'];
export const ALL_FORMATS = [...IMG_FORMATS, ...DOC_FORMATS];
export const SUPPORTED_FORMATS = getSupportedFormatsString(ALL_FORMATS);
export const FILE_UPLOAD_INTERVAL = 5000;

export const PROCESS_STATUS = {
  INITIAL: 0,
  UPLOADING: 1,
  WAITING_RECOGNITION: 2,
  COMPLETED: 3,
};

export const DOCUMENTS_TYPES = {
  PASSPORT: 'passport',
  PASSPORT_MAIN: 'passport_main',
  PASSPORT_MAIN_HANDWRITTEN: 'passport_main_handwritten',
  PASSPORT_REGISTRATION_DEREGISTERED: 'passport_registration_deregistered',
  PASSPORT_REGISTRATION: 'passport_registration',
  PASSPORT_REGISTRATION_HANDWRITTEN: 'passport_registration_handwritten',
  PASSPORT_BLANK_PAGE: 'passport_blank_page',
  PASSPORT_MILITARY: 'passport_military',
  PASSPORT_MARRIAGE: 'passport_marriage',
  PASSPORT_CHILDREN: 'passport_children',
  PASSPORT_PREVIOUS_DOCS: 'passport_previous_docs',
  PASSPORT_ZERO_PAGE: 'passport_zero_page',
  PASSPORT_LAST_RF: 'passport_last_rf',
  DRIVER_LICENCE: 'driving-licence',
  PERSONAL_DATA: 'personal-data',
  INTERNATIONAL_PASSPORT: 'international-passport',
  MILITARY_ID: 'military-id',
  SNILS: 'snils',
  PTS: 'pts',
  INN: 'inn',
  JOB_INCOME_DOCUMENTS: 'job-income-docs',
  CUSTOMER_FOTO: 'foto-customer',
  OTHER: 'customer-other-files',
};

export const PASSPORT_PAGE_NUMBERS = [
  '2-3',
  '4-5',
  '6-7',
  '8-9',
  '10-11',
  '12-13',
  '14-15',
  '16-17',
  '18-19',
];
export const DRIVING_LICENSE_PAGE_NUMBERS = ['1', '2'];

export const PASSPORT_PAGES_ORDER = [
  'passport_main',
  'passport_main_handwritten',
  'passport_registration_deregistered',
  'passport_registration',
  'passport_registration_handwritten',
  'passport_blank_page',
  'passport_military',
  'passport_marriage',
  'passport_children',
  'passport_previous_docs',
  'passport_zero_page',
  'passport_last_rf',
];

export const FILE_UPLOAD_MESSAGES = {
  FAILED_TO_UPLOAD_FILES: 'Не удалось загрузить файлы',
  DOCUMENTS_UPLOAD_FAILED_RETRY: 'Документы не удалось загрузить, попробуйте еще раз',
  INVALID_FILE_FORMATS: `Неверный формат файлов. Поддерживаются: ${SUPPORTED_FORMATS}, макс. размер: ${MAX_MEGABYTE} мб`,
  DOCUMENTS_DELETION_COMPLETED: 'Удаление документов завершено',
  DOCUMENTS_RECOGNITION_COMPLETED: 'Распознавание документов завершено',
};

export const DOCUMENT_SIDE = {
  FRONT: 'front',
  BACK: 'back',
};

export const CONTROLS_NAMES = {
  CHANGE_DOCUMENT_TYPE: 'Изменить тип документа',
  DOWNLOAD: 'Скачать',
  DELETE: 'Удалить',
};

export const LIST_OPTIONS = {
  nav: false,
  loop: false,
  center: true,
  gutter: 10,
  edgePadding: 0,
  items: 6,
  responsive: {
    1280: {
      items: 6,
    },
    1440: {
      items: 6,
    },
  },
};
